var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controls"},[_c('audio-player-timeline',{attrs:{"trackSlug":_vm.trackSlug,"hotspots":_vm.hotspots},on:{"change":function($event){return _vm.onTimeChange()},"input":function($event){return _vm.onTimeInput()}},model:{value:(_vm.timeValue),callback:function ($$v) {_vm.timeValue=_vm._n($$v)},expression:"timeValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }